import store from "@builder/store/store";
import { getMinorUnitsFromCurrency } from "@common/utils/amountUtils";

export function formatCurrency(amount?: number | string, companySettings?: any): string {
    if (amount === undefined || amount === null) return "";

    try {
        const settings = companySettings || store.getState().storeData.company?.settings;
        if (!settings?.currency) return amount.toString();
        const currency: string = settings.currency;
        const minorUnits = getMinorUnitsFromCurrency(currency);
        const numeric = typeof amount === "string" ? parseFloat(amount) : amount;
        if (!Number.isFinite(numeric)) return amount.toString();
        const majorValue = numeric / Math.pow(10, minorUnits);
        return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency,
            minimumFractionDigits: minorUnits,
            maximumFractionDigits: minorUnits,
        }).format(majorValue);
    } catch {
        return amount.toString();
    }
}

export function formatAmount(amount?: number | string, decimalizable?: boolean, companySettings?: any): string {
    if (amount === undefined) return "";
    const numeric = typeof amount === "string" ? parseFloat(amount) : amount;

    try {
        const settings = companySettings || store.getState().storeData?.company?.settings;
        if (!settings) return numeric.toString();
        const currency: string = settings.currency;
        const minorUnits = currency ? getMinorUnitsFromCurrency(currency) : (settings.decimals ?? 2);
        const howManyDecimals = decimalizable ? minorUnits : 0;
        const majorValue = numeric / Math.pow(10, minorUnits);
        const decimalSeparator = settings.decimalSeparator || ".";
        const thousandSeparator = settings.thousandSeparator || ",";
        const [integer, decimal] = majorValue.toFixed(howManyDecimals).split(".");
        //eslint-disable-next-line
        const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
        return decimal ? `${formattedInteger}${decimalSeparator}${decimal}` : formattedInteger;
    } catch {
        return numeric.toString();
    }
}

/**
 * Formats and parses the component and identifier to a valid test id
 * @param component - The component name - e.g. "onboard-input", "select-input", "button"
 * @param identifier - The unique identifier for the component, e.g. component key, label, id
 * @returns The formatted test id - e.g. "onboard-input-first-name", "select-input-how-would-you-categorize-your-organization"
 */
export function formatTestId(component: string, identifier: string): string {
    return `${component}-${identifier.toLowerCase().replace(/[.,'?]/g, "").replace(/ /g, "-")}`;
}
